import PropTypes from 'prop-types';
import FormInText from './FormInText';
import SignupForm from './SignupForm';

const NewsletterSignup = ({
  embed,
  title,
  toastCaption,
  buttonTitle,
  salesForceCampaignId,
  children
}) => {
  if (embed === 'true') {
    return (
      <SignupForm
        title={title}
        toastCaption={toastCaption}
        salesForceCampaignId={salesForceCampaignId}>
        {children}
      </SignupForm>
    );
  }

  return (
    <FormInText
      title={title}
      toastCaption={toastCaption}
      subtitle={buttonTitle}
      salesForceCampaignId={salesForceCampaignId}>
      {children}
    </FormInText>
  );
};

NewsletterSignup.propTypes = {
  embed: PropTypes.string,
  title: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  toastCaption: PropTypes.string,
  salesForceCampaignId: PropTypes.string,
  children: PropTypes.node.isRequired
};

NewsletterSignup.defaultProps = {
  embed: '',
  toastCaption: 'Newsletter subscription sent successfully',
  salesForceCampaignId: ''
};

export default NewsletterSignup;
